export * from '../../core/components/ApplicationContext';
export {ApplicationProvider as default} from '../../core/components/ApplicationContext';